import NgFormDecorator from './NgFormDecorator';
import EmailInputDecorator from './EmailInputDecorator';

angular.module('edge.platform.decorator', []).config(['$provide', NgFormDecorator]).config(['$provide', EmailInputDecorator]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/decorator/module.js
// module id = 1031
// module chunks = 0